module.exports = __webpack_public_path__ + "img/ruby-logo.01009004.png";